import React, { FC, useEffect, useState } from 'react'
import { Icon } from '@cps'
import './index.scss'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  showType?: 0 | 1;
  targetTop: number;
  nowTop: number;
  type?: 'product' | 'OptionalCombo' | 'FixedCombo';
  onChange: (data: any) => void;
}

const ScrollScaleBar: FC<IProps> = ({ targetTop = 0, nowTop = 0, type = '', onChange }) => {
  const winHeight = window.innerHeight
  const [stepLong, setStepLong] = useState(0)
  const [opacity, setOpacity] = useState(1)
  useEffect(() => {
    setStepLong(targetTop - winHeight)
  }, [])
  useEffect(() => {
    setOpacity(nowTop ? (stepLong - nowTop) / stepLong : 1)
  }, [nowTop])

  return (
    <div className={`product-scroll-scale-bar-container ${type}`} style={{ display: opacity <= 0 ? 'none' : 'block' }}>
      <div className='product-scroll-scale-bar-wrapper' style={{ opacity }} onClick={onChange}>
        <span className='txt'>{i18n.t('productdetail.scrollDownChangeScale')}</span>
        <Icon name='jiantou' />
      </div>
    </div>
  )
}

export default ScrollScaleBar
